// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__8vxf0","footer":"App_footer__PSOrj"};